import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { NavigationUtil } from 'utils/NavigationUtil';
import { CmsPagesActions } from 'modules/cmsPages/actions';
import { CmsPagesSelector } from 'modules/cmsPages/selector';
import { EventActions } from 'modules/event/actions';
import { EventSelector } from 'modules/event/selector';
import { HomeActions } from 'modules/home/actions';
import { HomeSelector } from 'modules/home/selector';
import { PageLoader } from 'components/molecules/pageLoader';
import BeliefStatementsSection from 'components/templates/beliefStatementsSection';
import { ContactUsSection } from 'components/templates/contactUsSection';
import FooterSection from 'components/templates/footer';
import { HeroSection } from 'components/templates/heroSection';
import PageTemplate from 'components/templates/pageTemplate';
import { isEmpty } from 'lodash';
import { RouteNames } from 'router';
import RenderSEO from 'components/atoms/renderSEO';
import { ProjectAnnouncementsSection } from 'components/templates/projectAnnouncementsSection';
import { ProjectSelector } from 'modules/project/selector';
import { ProjectActions } from 'modules/project/actions';
import { FooterActions } from 'modules/footerLink/actions';
import { FooterSelector } from 'modules/footerLink/selector';

const HomePage = props => {
  const {
    isLoading,
    isUpcomingEventsLoading,
    isCmsPageLoading,
    getBannerData,
    bannerData,
    getPageData,
    cmsPageData,
    cmsMobilePageData,
    getContactDetails,
    contact,
    footerLink,
    getFooterLinkData,
    getVerticals,
    verticals,
    verticalId,
    getSiteSettings,
    siteSettings,
    getUpcomingShows,
    upcomingShows,
    getAnnouncements,
    announcements,
    // latestShow,
  } = props;

  const metaTagSEO = {
    metaTitle: 'Total Environment | Apartments | Villas | India',
    metaDescription:
      "Total Environment has delivered more than 6 million square feet to over 1,600 customers across many projects in Bangalore, Pune, Hyderabad, and Frisco, TX. While these numbers demonstrate the scale of our operations and our ability to influence modern housing, they tell only one side of the story. What truly moves and inspires us is our love for good design and the joy of giving people a place to proudly call home. Our commitment to further design thinking and practices will always be first and foremost, no matter what project we're embarking on.",
    metaKeywords: '',
  };

  const isMobile = useMediaQuery({ query: '(max-device-width: 560px)' });
  const [theme, setTheme] = useState('light-theme');

  useEffect(() => {
    getAnnouncements();
    getBannerData();
    getContactDetails();
    getVerticals();
    getUpcomingShows();
    getSiteSettings();
    getPageData();
    getFooterLinkData();
  }, []);

  if (isLoading || isUpcomingEventsLoading || isCmsPageLoading) {
    return <PageLoader isMobile={isMobile} />;
  }

  if (
    !bannerData ||
    !cmsMobilePageData ||
    !cmsPageData ||
    !contact ||
    !announcements ||
    !verticals ||
    !footerLink
  ) {
    return null;
  }

  bannerData &&
    bannerData.data.page_banners.map(banner => {
      if (banner.type === 'Home') {
        if (banner.meta_title) metaTagSEO.metaTitle = banner.meta_title;
        if (banner.meta_description)
          metaTagSEO.metaDescription = banner.meta_description;
        if (banner.meta_keyword) metaTagSEO.metaKeywords = banner.meta_keyword;
      }
    });

  const componentList = [
    ...(!isEmpty(bannerData.data.page_banners)
      ? [
          {
            component: HeroSection,
            data: bannerData,
            origin: 'landing',
            sectionId: 'banner',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Home',
                breadcrumbLink: '#',
              },
            ],
            theme: 'light-theme',
          },
        ]
      : []),
    ...(!isEmpty(cmsPageData.cms_pages)
      ? [
          {
            component: BeliefStatementsSection,
            data: { cmsPageData, upcomingShows },
            mobileBannerData: { cmsMobilePageData, upcomingShows },
            sectionId: 'our-values',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Our Values',
                breadcrumbLink: '#',
              },
            ],
            theme: 'light-theme',
          },
        ]
      : []),
    ...(!isEmpty(announcements)
      ? [
          {
            component: ProjectAnnouncementsSection,
            data: { announcements },
            sectionId: 'announcements',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Announcements',
                breadcrumbLink: '#',
              },
            ],
            theme: 'dark-theme',
            sectionName: 'announcement-section',
          },
        ]
      : []),
    {
      component: ContactUsSection,
      data: { contact, verticals, verticalId, callPostLeadAPI: true },
      location: props,
      sectionId: 'contact',
      breadcrumbList: [
        {
          breadcrumbName: 'TotalEnvironment',
          breadcrumbLink: RouteNames.landing,
        },
        {
          breadcrumbName: 'Contact Us',
          breadcrumbLink: '#',
        },
      ],
      theme: 'light-theme',
    },
    {
      component: FooterSection,
      theme: 'dark-theme',
      sectionId: 'te-links',
      breadcrumbList: [
        {
          breadcrumbName: 'TotalEnvironment',
          breadcrumbLink: RouteNames.landing,
        },
        {
          breadcrumbName: 'Links',
          breadcrumbLink: '#',
        },
      ],
      data: { siteSettings, footerLink },
    },
  ];

  return (
    <>
      <RenderSEO metaTags={metaTagSEO} />
      <PageTemplate
        componentList={componentList}
        theme={theme}
        updateTheme={e => setTheme(e)}
        verticals={verticals}
        siteSettings={siteSettings}
        showGetInTouch={false}
        showShareButton={false}
      />
    </>
  );
};

const mapStateToProps = (state, props) => {
  const verticalKey = NavigationUtil.getVerticalKeyForLocation(props.location);

  return {
    isLoading: FooterSelector.isLoading(state) || HomeSelector.isLoading(state),
    isUpcomingEventsLoading: EventSelector.getUpcomingEventsLoading(state),
    isCmsPageLoading: CmsPagesSelector.isCmsPageLoading(state),
    bannerData: HomeSelector.getBannerData(state),
    cmsPageData: CmsPagesSelector.getPageData(state),
    cmsMobilePageData: CmsPagesSelector.getPageDataMobile(
      state,
      'Belief Statements'
    ),
    contact: HomeSelector.getContactForVertical(state, verticalKey),
    verticalId: HomeSelector.getVerticalIdForKey(verticalKey),
    siteSettings: HomeSelector.getSiteSettings(state),
    verticals: HomeSelector.getVerticals(state),
    footerLink: FooterSelector.getFooterData(state),
    upcomingShows: EventSelector.getUpcomingEvents(state),
    announcements: ProjectSelector.getAnnouncements(state),
    // latestShow: EventSelector.getLatestShow(state),
  };
};

const mapDispatchToProps = dispatch => {
  const {
    getBannerData,
    getContactDetails,
    getVerticals,
    getSiteSettings,
  } = HomeActions;
  const { getPageData } = CmsPagesActions;
  const { getUpcomingEvents } = EventActions;
  const { getFooterLinkData } = FooterActions;
  const { getAnnouncements, getProjects } = ProjectActions;
  return bindActionCreators(
    {
      getBannerData,
      getContactDetails,
      getVerticals,
      getUpcomingShows: getUpcomingEvents,
      getSiteSettings,
      getPageData,
      getAnnouncements,
      getFooterLinkData,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
